import $ from 'jquery';
import pjax from 'pjax';
import avalon from 'avalon';
import ajax from 'ajax';
import tool from 'toolLoaderPC';
import dialog from 'dialog';
import lazyload from 'lazyload';
import dialogBlank from '../modules/dialog/0.0.0/dialog.blank';
import vueModules from './js_modules/vue/index';
import controllers from './js_modules/controllers';
import './js_modules/plugins/skin';
import './index.scss';

if ($('[ms-controller]').length) {
    avalon.config({
        interpolate: ['[[', ']]']
    });

    dialogBlank(avalon);
    lazyload.init($, window, document);

    var gHiddenValues = tool.getHiddenValues('#js-hiddens');

    pjax($);

    console.log(gHiddenValues);


//     var noCache = ['']



// // 利用地址控制缓存

//     if(noCache.indexOf('') !== -1){



//     }

    $.pjax.defaults.maxCacheLength = 0;

    $(document).pjax('a[data-pjax]', '#pjax-container');
   

    if ($.pjax.defaults) {
        $.pjax.defaults.timeout = 50000;
        $.pjax.defaults.except = [gHiddenValues.mall];
    }

    $(document)
        .on('pjax:send', function () {
            dialog.mask.show();
            dialog.progress.show(0);
            setTimeout(function () {
                dialog.progress.show(70);
            }, 0);
        })
        .on('pjax:beforeReplace', function (event, doms) {
            $.each(doms, function (i, dom) {
                console.log(dom);
                var $dom = $(dom);
                if ($dom.hasClass('overlay') || $dom.hasClass('mask')) {
                    $dom.hide();
                }
            });
            dialog.mask.show();
            dialog.progress.show(100);
        })
        .on('pjax:end', function (xhr, options) {
            // 判断是否未登录
            try {
                var response = JSON.parse(options.responseText);
                if (response.code == 302) {
                    return ajax.jump(response.url);
                }
            } catch (e) {}

            setTimeout(function () {
                dialog.mask.hide();
                dialog.progress.hide();
                dialog.progress.width(0);
                dialog.clear();
            }, 500);
            $('#footer-top, #footer-bar').show();
            scan();
        })
        .on('pjax:error', function () {
            dialog.mask.hide();
            dialog.progress.hide();
            dialog.progress.width(0);
        })
        .on('pjax:timeout', function () {
            dialog.mask.hide();
            dialog.progress.hide();
            dialog.progress.width(0);
        });

    var scan = (function () {
        var lastController = null, // 上一个控制器
            pjaxContainer = $('#pjax-container'); // pjax的容器

        return function () {
            var avalonContainer, controllerId, controller, hiddenValues;

            avalonContainer = pjaxContainer.find('div[ms-controller]');
            if (avalonContainer.length <= 0) {
                avalonContainer = pjaxContainer.find('div[avalonctrl]');
            }

            controllerId =
                avalonContainer.attr('ms-controller') ||
                avalonContainer.attr('avalonctrl');
            (controller = controllers[controllerId]), // avalon控制器
            (hiddenValues = tool.getHiddenValues('#js-local-hiddens'));

            // tool.fixTitle(hiddenValues);

            if (controller) {
                lastController && lastController.clear();
                controller.init();
                avalon.scan(avalonContainer.get(0));
                lastController = controller;
            }
        };
    })();

    $(function () {
        scan();
        setTimeout(function () {
            $('#header .pop').css('top', '100%');
        }, 300);
        $('.mask').fadeOut();
        $('.overlay').fadeOut();
    });
} else if ($('[data-vue]').length) {
    let name = $('[data-vue]').data('vue');
    setTimeout(function () {
        $('#header .pop').css('top', '100%');
    }, 300);
    $('.mask').fadeOut();
    $('.overlay').fadeOut();
    let vm = vueModules[name]();
}

// 根据支付方式的不同执行不同的操作
window.operateAfterPay = function (response) {
    var data = response.message;

    if (data.channel_id == 0 || data.channel_id == 1 || !data.money) {
        // 金额为0直接支付 或 支付宝直接跳转
        ajax.jump(data.url);
    } else if (data.channel_id == 4) {
        // 微信直接弹出二维码
        var htmlStr = [
            '<div class="wx-pay-dialog">',
            '<div class="wx-pay-main">',
            '<div class="wx-pay-head">',
            '<div class="wx-pay-title">支付' + data.money + '元</div>',
            '<div class="wx-pay-close"><i class="iconfont">&#xe618;</i> </div>',
            '</div>',
            '<div class="wx-pay-des">微信扫码支付</div>',
            '<div class="wx-pay-qcode"><img src="' + data.url + '" > </div>',
            '<div class="wx-pay-operations">',
            '</div>',
            '</div>',
            '</div>'
        ].join('');

        $('body')
            .append(htmlStr)
            .on('click', '.wx-pay-close', function () {
                $('.wx-pay-dialog').remove();
                ajax.pjax('/order_list.html');

                if (queryWechatStateInterval) {
                    clearTimeout(queryWechatStateInterval);
                }
            });

        // 支付成功后需要轮休后台查询支付的状态
        var kit;
        var queryWechatStateInterval;
        queryWechatStateInterval = setTimeout(queryWechatState, 1000);

        function queryWechatState () {
            tool.singleWay('query-wechat-state', function (key) {
                kit = this;

                ajax.get('order/default/check-is-finished.html', {
                    orderId: data.orderId
                })
                    .done(function (resp) {
                        if (resp.type === 'succ') {
                            if (queryWechatStateInterval) {
                                clearTimeout(queryWechatStateInterval);
                            }
                            var dialog = $('.wx-pay-dialog');
                            if (dialog.length) {
                                dialog.remove();
                                ajax.pjax('/order_list.html');
                            }
                        } else {
                            if (queryWechatStateInterval) {
                                clearTimeout(queryWechatStateInterval);
                            }

                            queryWechatStateInterval = setTimeout(
                                queryWechatState,
                                1000
                            );
                        }

                        kit.resolve(key);
                    })
                    .fail(function () {
                        if (queryWechatStateInterval) {
                            clearTimeout(queryWechatStateInterval);
                        }

                        queryWechatStateInterval = setTimeout(
                            queryWechatState,
                            1000
                        );

                        kit.resolve(key);
                    });
            });
        }
    }
};

// 美洽客服
$(function () {
    var entId = $("#js-hiddens input[name='meiqia']").val();
    (function (m, ei, q, i, a, j, s) {
        m[a] =
            m[a] ||
            function () {
                (m[a].a = m[a].a || []).push(arguments);
            };
        (j = ei.createElement(q)), (s = ei.getElementsByTagName(q)[0]);
        j.async = true;
        j.charset = 'UTF-8';
        j.src = i + '?v=' + new Date().getUTCDate();
        s.parentNode.insertBefore(j, s);
    })(
        window,
        document,
        'script',
        '//static.meiqia.com/dist/meiqia.js',
        '_MEIQIA'
    );
    _MEIQIA('entId', entId);

    var userId = $("[name='userid']").val();
    if (userId) {
        // 同步顾客身份
        _MEIQIA('clientId', userId);
    }

    // 在这里开启手动模式（必须紧跟美洽的嵌入代码）
    _MEIQIA('manualInit');

    _MEIQIA('init');

    // 获取顾客信息并传递
    _MEIQIA('allSet', function () {
        ajax.getJSON('/meiqia/user-info.html').done(function (response) {
            if (response.type == 'succ') {
                var msg = response.msg;
                var sendMeiqia = {
                    name: msg.username,
                    tel: msg.mobile,
                    总订单数: msg.order_total,
                    总订单额: msg.expendamount + '元',
                    最后订单: msg.last_order_time || '无',
                    未支付订单:
                        msg.orderInfo.unpaid[msg.orderInfo.unpaid.length - 1] ||
                        '无',
                    未发货订单:
                        msg.orderInfo.waiting_for_send[
                            msg.orderInfo.waiting_for_send.length - 1
                        ] || '无',
                    未确认订单:
                        msg.orderInfo.waiting_for_confirm[
                            msg.orderInfo.waiting_for_confirm.length - 1
                        ] || '无'
                };
                /// /循环未支付
                // for(var i = 0; i < msg.orderInfo.unpaid.length; i++){
                //    sendMeiqia['未支付订单' + (i + 1)] = msg.orderInfo.unpaid[i];
                // }
                //
                /// /循环未发货
                // for(var i = 0; i < msg.orderInfo.waiting_for_send.length; i++){
                //    sendMeiqia['未发货订单' + (i + 1)] = msg.orderInfo.waiting_for_send[i];
                // }
                //
                /// /循环未确认
                // for(var i = 0; i < msg.orderInfo.waiting_for_confirm.length; i++){
                //    sendMeiqia['未确认订单' + (i + 1)] = msg.orderInfo.waiting_for_confirm[i];
                // }

                // 传递顾客信息
                _MEIQIA('metadata', sendMeiqia);
            }
        });
    });
});

// 体育社登陆
function Empty (a) {
    return a == '' || void 0 == a || a == null ? !0 : !1;
}

window.tiyushe = tiyusheConfig || {};
tiyushe.avatar = function (a, b) {
    if (isNaN(a)) return '';
    Empty(b) && (b = 'small');
    var c = ('' + a).length,
        d = '';
    if (c < 9) {
        for (var e = 0; 9 - c > e; e++) d += '0';
        d += a;
    } else d = a;
    var f = d.substr(0, 3),
        g = d.substr(3, 2),
        h = d.substr(5, 2),
        i = f + '/' + g + '/' + h + '/' + d.slice(-2) + '_avatar_' + b + '.jpg';
    return tiyushe.domain + 'avatar/' + i + '?' + a + '_avatar_append.jpg';
};
tiyushe.client_logged = function () {
    this.logged();
};
tiyushe.logged = function () {
    document.getElementById('head-unlogin').style.display = 'none';
    document.getElementById('user-avatar').src = tiyushe.avatar(
        tiyushe.passport.uid
    );
    document.getElementById('user-name').innerHTML = tiyushe.passport.username;
    document.getElementById('head-personal').style.display = 'block';
};
tiyushe.unlogged = function () {
    document.getElementById('head-personal').style.display = 'none';
    document.getElementById('head-unlogin').style.display = 'block';
};
(function () {
    function ISC (a) {
        for (var b in a) {
            var c = document.createElement('script');
            (c.type = 'text/javascript'), (c.async = !0), (c.src = a[b]);
            var d = document.getElementsByTagName('script')[0];
            d.parentNode.insertBefore(c, d);
        }
    }
    ISC([tiyushe.passportJsUrl]);
})();



// WEBPACK FOOTER //
// ./src/index.js